import LegalLayout from '../components/legal/LegalLayout';

export default function TermsPage() {
  return <LegalLayout title="Terms & conditions" dataId="28b02d92-bdb3-4812-868d-cb77b7a70d6a" />;
}
